module.exports = __webpack_public_path__ + "img/steyr_stadtpfarrkirche_raum_2014_ref.abb52e8b.jpg";